import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import errorTracker from './utils/errorTracker';

// Try to initialize error tracking with safer options
try {
  errorTracker.init({
    captureUnhandledErrors: true,
    capturePromiseRejections: true,
    captureNetworkErrors: false, // Disable network error tracking temporarily
    captureConsoleErrors: false, // Disable console error tracking temporarily
    reportErrors: false, // Disable reporting until server is ready
  });
} catch (err) {
  console.error('Failed to initialize error tracking:', err);
}

// The AuthProvider and InventoryProvider are already included in the App component
// Let's avoid duplicate providers
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);